package com.nonopn.skywatcher.common.app.pages.scan

data class ScanQrContentModelState(
    val isInviting: Boolean = false,
    val isWaitingAlertDismiss: Boolean = false,
    val invitationError: Throwable? = null
)
